import { AnyAction, Middleware } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { AppRootState } from "@/store";
import * as chatActivitySlice from "@/store/communication/chatActivityOverviewSlice";
import * as chatHistorySlice from "@/store/communication/chatHistorySlice";
import * as chatMessagesSlice from "@/store/communication/chatMessagesSlice";

import { GetTypedPayload } from "../ts";

export const communicationMiddleware: Middleware<
  any,
  AppRootState,
  ThunkDispatch<any, any, AnyAction>
> =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    if (chatMessagesSlice.newChatMessageReceived.match(action)) {
      const payload = GetTypedPayload(action, chatMessagesSlice.newChatMessageReceived);

      await dispatch(
        chatActivitySlice.trackMyChatActivity({
          chatId: payload.chatId,
          message: payload.message,
        }),
      );
    } else if (chatHistorySlice.newChatEventReceived.match(action)) {
      const payload = GetTypedPayload(action, chatHistorySlice.newChatEventReceived);

      await dispatch(
        chatActivitySlice.trackMyChatActivity({
          chatId: payload.chatId,
          event: payload.event,
        }),
      );
    }

    return next(action);
  };
